import { createSlice } from '@reduxjs/toolkit'

export const propertySlice = createSlice({
    name: "counter",
    initialState: {
        searchFilter: {
            keyword: { value: "", fieldName: "keyword" },

            province: {
                value: "", fieldName: "province", placeholderSearch: "ชื่อจังหวัด", placeholder: "จังหวัด", clearOption: true,
                option: []
            },
            district: {
                value: "", fieldName: "district", placeholderSearch: "ชื่อเขต/อำเภอ", placeholder: "เขต/อำเภอ", clearOption: true,
                option: []
            },
            subDistrict: {
                value: "", fieldName: "subDistrict", placeholderSearch: "ชื่อแขวง/ตำบล", placeholder: "แขวง/ตำบล", clearOption: true,
                option: []
            },
            station: {
                value: "", fieldName: "station", placeholderSearch: "ชื่อสถานี", placeholder: "เลือกสถานีใกล้เคียง", clearOption: true,
                option: []
            },

            order: {
                value: "hot", fieldName: "order", minimumResultsForSearch: -1, notShowEmptyOption: true, option: [
                    { text: "ทรัพย์ยอดนิยม", value: "hot" },
                    { text: "ทรัพย์มาใหม่", value: "new" },
                    { text: "ราคา (น้อย-มาก)", value: "min-max" },
                    { text: "ราคา (มาก-น้อย)", value: "max-min" },
                    { text: "พื้นที่ (น้อย-มาก)", value: "min-max-area" },
                    { text: "พื้นที่ (มาก-น้อย)", value: "max-min-area" },
                ]
            },

            propertyType: {
                value: "", fieldName: "propertyType",
                housetype: { value: false, code: "02", name: "บ้านเดี่ยว", fieldName: "housetype", group: "propertyType" },
                land: { value: false, code: "01", name: "ที่ดิน", fieldName: "land", group: "propertyType" },
                townhouse: { value: false, code: "03", name: "ทาวน์เฮ้าส์", fieldName: "townhouse", group: "propertyType" },
                condo: { value: false, code: "05", name: "คอนโดมิเนียม", fieldName: "condo", group: "propertyType" },
                commercialbuilding: { value: false, code: "04", name: "อาคารพาณิชย์", fieldName: "commercialbuilding", group: "propertyType" },
                warehouse: { value: false, code: "12", name: "โกดัง", fieldName: "warehouse", group: "propertyType" },
                factory: { value: false, code: "09", name: "โรงงาน", fieldName: "factory", group: "propertyType" },
                apartment: { value: false, code: "15", name: "อพาร์ทเม้นท์", fieldName: "apartment", group: "propertyType" },
                office: { value: false, code: "10", name: "อาคารสำนักงาน", fieldName: "office", group: "propertyType" },
                resort: { value: false, code: "20", name: "รีสอร์ท", fieldName: "resort", group: "propertyType" },
                houseother: { value: false, code: "19", name: "อื่น ๆ", fieldName: "houseother", group: "propertyType" },
            },
            rangePrice: {
                value: "", fieldName: "rangePrice", min: 0, max: 11, from: 0, from_value: 0, to: 0, to_value: 0, step: 1, count: 0, placeholder: "ราคาเริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "1 ล้านบาท", "3 ล้านบาท", "5 ล้านบาท", "10 ล้านบาท", "20 ล้านบาท", "50 ล้านบาท"
                ]
            },
            areaRange: {
                value: "", fieldName: "areaRange", min: 0, max: 8, from: 0, to: 0, step: 50, count: 0, placeholder: "เนื้อที่เริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "50 ตร.ว.", "100 ตร.ว.", "200 ตร.ว.", "300 ตร.ว.", "1 ไร่", "5 ไร่", "10 ไร่", "50 ไร่"
                ]
            },
            useableAreaRange: {
                value: "", fieldName: "useableAreaRange", min: 0, max: 150, from: 0, to: 0, step: 50, count: 0, placeholder: "พื้นที่เริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "30 ตร.ม.", "50 ตร.ม.", "100 ตร.ม.", "200 ตร.ม.", "500 ตร.ม.",
                ]
            },
            rangeField: {value: "", fieldName: "rangePrice"},
            areaField: {value: "", fieldName: "areaRange"},
            useableAreaField: {value: "", fieldName: "useableAreaRange"},
            bedroom: { value: 0, min: 0, max: 99, fieldName: "bedroom" },
            bathroom: { value: 0, min: 0, max: 99, fieldName: "bathroom" },
            assetTypes: {
                value: "", fieldName: "assetTypes",
                // PromotionProperties: { value: false, code: "PromotionProperties", name: "บ้านเดี่ยว", fieldName: "PromotionProperties" }, // fieldName is icon classname
                propertybank: { value: false, code: "kbank", name: "ทรัพย์<br>ธนาคาร", fieldName: "propertybank", group: "assetTypes" },
                propertywaitsale: { value: false, code: "npl", name: "ทรัพย์<br>ฝากขาย", fieldName: "propertywaitsale", group: "assetTypes" },
                partnership: { value: false, code: "partner", name: "ทรัพย์<br>ผู้ขาย", fieldName: "partnership", group: "assetTypes", spanText: "(บุคคลภายนอก)" },
            },
            expand: { value: "", fieldName: "expand" },
        },
        searchResult: {
            keyword: { value: "", fieldName: "keyword" },
            resultLength: { value: 0, fieldName: "resultLength" },
            Allow_Cookies: { value: true, fieldName: "Allow_Cookies" },
            showTab: { value: "newProperty", fieldName: "showTab" },
            newProperty: { value: "", fieldName: "newProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false, TotalRows: 0 },
            promoProperty: { value: "", fieldName: "promoProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false, TotalRows: 0 },
            popularProperty: { value: "", fieldName: "popularProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false, TotalRows: 0 },
            favoriteProperty: { value: "", fieldName: "favoriteProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false, favoritePropertyList: [], TotalRows: 0 },
            recentlyviewedProperty: { value: "", fieldName: "recentlyviewedProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false, TotalRows: 0 },
            suggestProperty: { value: "", fieldName: "suggestProperty", list: [], pageIndex: 1, hasMore: true, isLoading: false },
        },
        propertyDetail: {
            AssetInfoTH: "",
            AddressNoTH: "",
            BuildingTH: "",
            FloorTH: "",
            VillageTH: "",
            SoiTH: "",
            RoadTH: "",
            TambonName: "",
            AmphurName: "",
            ProvinceName: "",
            location: "",
            PropertyTypeName: "",
            Bedroom: "",
            Bathroom: "",
            CarParking: "",
            SellPrice: "",
            PromotionPrice: "",
            AdjustPrice: "",
            PromotionName: "",
            PromotionRemark: "",
            PropertyIDFormat: "",
            PropertyID: "",
            Area: "",
            AreaValue: "",
            UseableArea: "",
            ShowAreaValue: "",
            ShowUseableArea: "",
            PropertyMediaes: [],
            GAScore: "",
            Like: "",
            IsNew: "",
            CategoryGroup:"",
            CategoryDetail: "",
            AIImg: [],
            
            // AssetInfoTH: { value: "", fieldName: "AssetInfoTH" },
            // AddressNoTH: { value: "", fieldName: "AddressNoTH" },
            // BuildingTH: { value: "", fieldName: "BuildingTH" },
            // FloorTH: { value: "", fieldName: "FloorTH" },
            // VillageTH: { value: "", fieldName: "VillageTH" },
            // SoiTH: { value: "", fieldName: "SoiTH" },
            // RoadTH: { value: "", fieldName: "RoadTH" },
            // TambonName: { value: "", fieldName: "TambonName" },
            // AmphurName: { value: "", fieldName: "AmphurName" },
            // ProvinceName: { value: "", fieldName: "ProvinceName" },
            // location: { value: "", fieldName: "location" },
            // PropertyTypeName: { value: "", fieldName: "PropertyTypeName" },
            // Bedroom: { value: "", fieldName: "Bedroom" },
            // Bathroom: { value: "", fieldName: "Bathroom" },
            // SellPrice: { value: "", fieldName: "SellPrice" },
            // PromotionPrice: { value: "", fieldName: "PromotionPrice" },
            // AdjustPrice: { value: "", fieldName: "AdjustPrice" },
            // PromotionName: { value: "", fieldName: "PromotionName" },
            // PromotionRemark: { value: "", fieldName: "PromotionRemark" },
            // PropertyIDFormat: { value: "", fieldName: "PropertyIDFormat" },
            // PropertyID: { value: "", fieldName: "PropertyID" },
            // Area: { value: "", fieldName: "Area" },
            // AreaValue: { value: "", fieldName: "AreaValue" },
            // UseableArea: { value: "", fieldName: "UseableArea" },
            // PropertyMediaes: { value: "", fieldName: "PropertyMediaes" },
            // GAScore: { value: "", fieldName: "GAScore" },
            // Like: { value: false, fieldName: "Like" },
        },
        dropleadDetail: {
            usertype: { value: 'normal' },
            juJuristicId: { value: '', required: true, errorMessage: '', fieldName: 'juJuristicId', label: 'เลขที่นิติบุคคล', placeholder: "กรุณากรอกเลขที่นิติบุคคล*", maxLength: 250, inputmode: "numeric" },
            juFirstName: { value: '', required: true, errorMessage: '', fieldName: 'juFirstName', label: 'ชื่อ', placeholder: "กรุณากรอกชื่อ*", maxLength: 250 },
            juLastName: { value: '', required: true, errorMessage: '', fieldName: 'juLastName', label: 'นามสกุล', placeholder: "กรุณากรอกนามสกุล*", maxLength: 250 },

            phone: { value: '', required: true, errorMessage: '', fieldName: 'phone', label: 'เบอร์มือถือ', placeholder: "กรุณากรอกเบอร์มือถือ*", maxLength: 10, inputmode: "numeric" },
            confirmphone: { value: '', required: true, errorMessage: '', fieldName: 'confirmphone', label: 'ยืนยันเบอร์มือถือ', placeholder: "กรุณายืนยันเบอร์มือถือ*", maxLength: 10, inputmode: "numeric" },

            naCitizenId: { value: '', required: true, errorMessage: '', fieldName: 'naCitizenId', label: 'เลขบัตรประชาชน', placeholder: "กรุณากรอกเลขบัตรประชาชน*", maxLength: 13, inputmode: "numeric" },

            email: { value: '', required: true, errorMessage: '', fieldName: 'email', label: 'อีเมล', placeholder: "กรุณากรอกอีเมล*", maxLength: 250 },
            consentCheck: { value: true, required: true, errorMessage: '', fieldName: 'consentCheck', label: 'สนใจสินเชื่อทรัพย์มือสอง', placeholder: "0" },

            juCompanyName: { value: '', required: true, errorMessage: '', fieldName: 'juCompanyName', label: 'ชื่อบริษัท', placeholder: "ชื่อบริษัท*", maxLength: 500 },
            naFirstName: { value: '', required: true, errorMessage: '', fieldName: 'naFirstName', label: 'ชื่อ', placeholder: "ชื่อ*", maxLength: 250 },
            naLastName: { value: '', required: true, errorMessage: '', fieldName: 'naLastName', label: 'นามสกุล', placeholder: "นามสกุล*", maxLength: 250 },
            naCareer: {
                value: '', required: true, errorMessage: '', fieldName: 'naCareer', label: 'อาชีพ', placeholder: "อาชีพ*",
                option: [
                ]
            },
            naSalary: { value: '', required: true, errorMessage: '', fieldName: 'naSalary', label: 'รายได้ต่อเดือน', placeholder: "รายได้ต่อเดือน*", maxLength: 250, inputmode: "numeric" },

            availableTime: {
                value: '', required: true, errorMessage: '', fieldName: 'availableTime', label: 'ช่วงเวลาที่สะดวกให้ติดต่อกลับ', placeholder: "ช่วงเวลาที่สะดวกให้ติดต่อกลับ*",
                option: [
                ]
            },
        },
        calcDetail: {
            propertyTypeID: { value: null },
            decoration: { value: null },
            definedPropertyPrice: { value: 0 },
            appraisalPrice: { value: 0 },
            calcTypes: {
                Home: 'Home Loan',
                Land: 'Land',
                SME: 'SME'
            },
            appliedCalcTypes: {
                value: {
                    forStay: null,
                    forBusiness: null,
                },
            },
            smePropertyType: { value: null },
            calculatorHomeLoanSetting: { value: 0, fieldName: "calculatorHomeLoanSetting" },
            calculatorLandSetting: { value: 0, fieldName: "calculatorLandSetting" },
            calculatorSMESetting: { value: 0, fieldName: "calculatorSMESetting" },

            stayTotalInstallmentPerMonth: { value: 0 },
            stayTotalLimitAmount: { value: 0 },
            stayInstallmentYear: { value: 0, maxLength: 2, maxDigit: 2, maxValue: 0, errorMessage: '', note: '' },
            stayPropertyLimitAmount: { value: 0, maxLength: 11, maxDigit: 9, maxValue: 0, errorMessage: '' },
            stayPropertyInstallmentPerMonth: { value: 0 },
            stayDecorationLimitAmount: { value: 0, maxLength: 11, maxDigit: 9, maxValue: 0, errorMessage: '' },
            stayDecorationInstallmentPerMonth: { value: 0 },
            stayIncomePerMonth: { value: 0, maxLength: 11, maxDigit: 9, minValue: 7500, errorMessage: '' },
            stayDebtBurdenPerMonth: { value: 0, maxLength: 11, maxDigit: 9, errorMessage: '' },
            stayCanTakeDecoration: { value: true },

            businessTotalInstallmentPerMonth: { value: 0 },
            businessTotalLimitAmount: { value: 0 },
            businessInstallmentYear: { value: 0, maxLength: 2, maxValue: 0, errorMessage: '', note: '' },
            businessPropertyLimitAmount: { value: 0, maxLength: 11, maxDigit: 9, maxValue: 0, errorMessage: '' },
            businessPropertyInstallmentPerMonth: { value: 0 },
            businessDecorationLimitAmount: { value: 0, maxLength: 11, maxDigit: 9, maxValue: 0, errorMessage: '' },
            businessDecorationInstallmentPerMonth: { value: 0 },
            businessIncomePerMonth: { value: 0, maxLength: 11, maxDigit: 9, errorMessage: '' },
            businessDebtBurdenPerMonth: { value: 0, maxLength: 11, maxDigit: 9, errorMessage: '' },

            stayValidateFields: { value: [] },
            businessValidateFields: { value: [] },

            // calcType: { value: '' },
            // price: { value: '', required: true, errorMessage: '', fieldName: 'price', label: 'ราคาทรัพย์/ราคาเสนอซื้อ (บาท)', placeholder: "0" },
            // income: { value: '', required: true, errorMessage: '', fieldName: 'income', label: 'รายได้ต่อเดือน (บาท) <span>ตั้งแต่ 7,500 บาท ขึ้นไป</span>', placeholder: "0" },
            // dept: { value: '', required: false, errorMessage: '', fieldName: 'dept', label: 'ภาระหนี้ต่อเดือน (บาท)', placeholder: "0" },
            // age: { value: '', required: true, errorMessage: '', fieldName: 'age', label: 'อายุผู้กู้ (ปี)', placeholder: "0", maxLength: 2 },
            // profit: { value: '', required: true, errorMessage: '', fieldName: 'profit', label: 'กำไรสุทธิต่อเดือน (บาท)', placeholder: "0" },
            // career: {
            //     value: '', required: true, errorMessage: '', fieldName: 'career', label: 'อาชีพ', placeholder: "เลือกอาชีพ",
            //     option: [
            //         { text: 'พนักงานประจำ', value: 'employee' },
            //         { text: 'เจ้าของกิจการ', value: 'business_owner' }
            //     ]

            // },
            // home: {
            //     value: '', required: true, errorMessage: '', fieldName: 'home', label: 'เลือกการกู้บ้านหลังที่', placeholder: "เลือกการกู้บ้านหลังที่",
            //     option: [
            //         { text: 'บ้านหลังที่ 1', value: 'home1' },
            //         { text: 'บ้านหลังที่ 2 (ผ่อนหลังที่ 1 มาแล้วไม่ถึง 2 ปี)', value: 'home2_with_home1_lessthan_2years' },
            //         { text: 'บ้านหลังที่ 2 (ผ่อนหลังที่ 1 มาแล้วตั้งแต่ 2 ปี ขึ้นไป)', value: 'home2_with_home1_2years_or_more' },
            //         { text: 'บ้านหลังที่ 3 เป็นต้นไป', value: 'home3_or_else' },
            //     ]

            // },
            // land: {
            //     value: '', required: true, errorMessage: '', fieldName: 'land', label: 'เป็นการกู้ซื้อทรัพย์ชิ้นที่', placeholder: "เลือกการกู้ซื้อทรัพย์ชิ้นที่",
            //     option: [
            //         { text: 'ทรัพย์ชิ้นที่ 1 (ไม่มีภาระสินเชื่อบ้านขณะนี้)', value: 'home1' },
            //         { text: 'ทรัพย์ชิ้นที่ 2 (ผ่อนหลังที่ 1 มาแล้วไม่ถึง 2 ปี)', value: 'home2_with_home1_lessthan_2years' },
            //         { text: 'ทรัพย์ชิ้นที่ 2 (ผ่อนหลังที่ 1 มาแล้วตั้งแต่ 2 ปีขึ้นไป)', value: 'home2_with_home1_2years_or_more' },
            //         { text: 'ทรัพย์ชิ้นที่ 3 เป็นต้นไป', value: 'home3_or_else' },
            //     ]

            // },
            // personType: {
            //     value: '', required: true, errorMessage: '', fieldName: 'personType', label: 'กู้ในนาม', placeholder: "เลือกกู้ในนาม",
            //     option: [
            //         { text: 'บุคคลธรรมดา', value: 'natural' },
            //         { text: 'นิติบุคคล', value: 'juristic' },
            //     ]

            // },
            // businessAge: {
            //     value: '', required: true, errorMessage: '', fieldName: 'businessAge', label: 'ระยะเวลาดำเนินธุรกิจ(ปี)', placeholder: "เลือกระยะเวลาดำเนินธุรกิจ",
            //     option: [
            //         { text: 'น้อยกว่า 6 เดือน', value: 'less_than_6m' },
            //         { text: '6 เดือน แต่ไม่ถึง 1 ปี', value: '6m_to_1y' },
            //         { text: '1-3 ปี', value: '1y_to_3y' },
            //         { text: 'มากกว่า 3 ปี', value: 'greater_than_3y' },
            //     ]

            // },
            // loanAmount: { value: "", fieldName: "loanAmount", min: 0, max: 11, from: 0, step: 1, count: 0 },
            // loanPeriod: { value: "", fieldName: "loanPeriod", min: 0, max: 11, from: 0, step: 1, count: 0 },
            // maxLimitResult: { value: 0, fieldName: "maxLimitResult" },
            // installmentResult: { value: 0, fieldName: "installmentResult" },
        },
        loading: null,
    },
    reducers: {
        searchDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchFilter[field].value = value;
        },
        searchListChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchFilter[field].value = "";
            state.searchFilter[field].option = value;
        },
        searchIonRangeChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;
            const from = action.payload.from;
            const to = action.payload.to;

            state.searchFilter[field].value = value;
            state.searchFilter[field].from = state.searchFilter[field].values.indexOf(from);
            if (to === "MAX") {
                state.searchFilter[field].to = state.searchFilter[field].max;
            }
            else {
                state.searchFilter[field].to = state.searchFilter[field].values.indexOf(to);
            }
        },
        searchIonRangeListChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;

            state.searchFilter[field].values = value;
        },
        updateIonRange: (state, action) => {
            const field = action.payload.fieldName;

            state.searchFilter[field].count += 1;
        },
        CheckBoxChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;
            const group = action.payload.group;

            const groupLength = Object.keys(state.searchFilter[group]).length - 2

            state.searchFilter[group][field].value = value;

            const temp = Object.entries(state.searchFilter[group]).map((item) => {
                if (item[0] !== "fieldName" && item[0] !== "value" && item[1].value) {
                    return item[1].code
                }
            }).filter(x => x);

            state.searchFilter[group].value = temp.length === groupLength ? "" : temp.join(',');

        },
        ClearSearch: (state, action) => {
            console.log("clear dis")
            Object.keys(state.searchFilter).forEach(function (key) {
                if (key === "bathroom" || key === "bedroom") {
                    state.searchFilter[key].value = 0
                } else if (key === "order") {
                    // state.searchFilter[key].value = "new"
                } else {
                    state.searchFilter[key].value = ""
                }
            });

            state.searchFilter.propertyType.housetype.value = false
            state.searchFilter.propertyType.land.value = false
            state.searchFilter.propertyType.townhouse.value = false
            state.searchFilter.propertyType.condo.value = false
            state.searchFilter.propertyType.commercialbuilding.value = false
            state.searchFilter.propertyType.warehouse.value = false
            state.searchFilter.propertyType.factory.value = false
            state.searchFilter.propertyType.apartment.value = false
            state.searchFilter.propertyType.office.value = false
            state.searchFilter.propertyType.resort.value = false
            state.searchFilter.propertyType.houseother.value = false

            state.searchFilter.assetTypes.propertybank.value = false
            state.searchFilter.assetTypes.propertywaitsale.value = false
            state.searchFilter.assetTypes.partnership.value = false

            state.searchFilter.rangePrice.from = 0
            state.searchFilter.rangePrice.to = 0
            state.searchFilter.rangePrice.count += 1
            state.searchFilter.areaRange.from = 0
            state.searchFilter.areaRange.to = 0
            state.searchFilter.areaRange.count += 1
            state.searchFilter.useableAreaRange.from = 0
            state.searchFilter.useableAreaRange.to = 0
            state.searchFilter.useableAreaRange.count += 1

        },
        updateSearchResultList: (state, action) => {
            const field = action.payload.fieldName;
            const list = action.payload.list;
            const hasMore = action.payload.hasMore;
            const TotalRows = action.payload.TotalRows;
            const suggest = action.payload.suggest;

            state.searchResult[field].list = list
            state.searchResult[field].hasMore = hasMore
            state.searchResult[field].TotalRows = TotalRows
            state.searchResult[field].suggest = suggest
        },
        likePropertyList: (state, action) => {
            let PropertyObjTemp = action.payload.PropertyObj;
            const PropertyID = PropertyObjTemp.PropertyID
            const listName = action.payload.listName;

            const like = PropertyObjTemp.like ? false : true

            let likeList = state.searchResult.favoriteProperty.value.split(',')

            if (like && !likeList.includes(PropertyID)) {
                state.searchResult.favoriteProperty.value = [...likeList, PropertyID].filter(x => x).join(',')

            } else if (!like && likeList.includes(PropertyID)) {
                state.searchResult.favoriteProperty.value = likeList.filter(x => x !== PropertyID).join(',')
            }

            var target = state.searchResult[listName].list.find(x => x.PropertyID === PropertyID)
            if (target) target.like = like


            // const PropertyObj = { ...PropertyObjTemp, like: like }

            // var target = state.searchResult.newProperty.list.find(x => x.PropertyID === PropertyID)
            // if (target) target.like = like
            // target = state.searchResult.promoProperty.list.find(x => x.PropertyID === PropertyID)
            // if (target) target.like = like
            // target = state.searchResult.popularProperty.list.find(x => x.PropertyID === PropertyID)
            // if (target) target.like = like
            // target = state.searchResult.recentlyviewedProperty.list.find(x => x.PropertyID === PropertyID)
            // if (target) target.like = like

            // // var target = state.searchResult[listName].list.find(x => x.PropertyID === PropertyID)
            // // if(target)target.like = like


            // if (like && !state.searchResult.favoriteProperty.list.find(x => x.PropertyID === PropertyID)) {
            //     state.searchResult.favoriteProperty.list.push(PropertyObj)
            // } else if (!like) {
            //     state.searchResult.favoriteProperty.list = state.searchResult.favoriteProperty.list.filter(function (obj) {
            //         return obj.PropertyID !== PropertyID;
            //     });
            // }

            // state.searchResult.favoriteProperty.value = state.searchResult.favoriteProperty.list.map(x => x.PropertyID).join(',')
        },
        updateLikeInList: (state, action) => {
            const listName = action.payload.listName;
            const PropertyLikeList = action.payload.PropertyLikeList
            const targetList = state.searchResult[listName].list

            if (PropertyLikeList && targetList.length > 0) {
                const list = PropertyLikeList.split(',')
                Array.from(targetList, x => {
                    if (list.includes(x.PropertyID)) {
                        x.like = true
                    } else {
                        x.like = false
                    }
                })
            }

        },
        updatesearchFilterCheckBox: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchFilter[field].value = value

            value.split(',').forEach((valueCode) => {
                let toUpdate = Object.keys(state.searchFilter[field]).find(x => state.searchFilter[field][x].code === valueCode)
                if (state.searchFilter[field][toUpdate]) {
                    state.searchFilter[field][toUpdate].value = true
                }
            })

            Object.keys(state.searchFilter[field]).forEach((key) => {
                if (key !== "fieldName" && key !== "value" && state.searchFilter[field][key].code === value) {
                    state.searchFilter[field][key].value = true
                }
            });
        },
        searchResultDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchResult[field].value = value;
        },
        OnPropertyListLoading: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchResult[field].isLoading = value;
        },
        searchResultPageIndexChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchResult[field].pageIndex = value;
        },
        updatePropertyDetail: (state, action) => {
            const value = action.payload.value;
            state.propertyDetail = value

            // Object.keys(value).forEach((key)=>{
            //     if(state.propertyDetail[key]){
            //         state.propertyDetail[key].value = value[key];
            //     }
            // })
        },
        formsCalcDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;
            const maxValue = action.payload.maxValue;
            const minValue = action.payload.minValue;
            const errorMessage = action.payload.errorMessage;
            const visible = action.payload.visible;
            const note = action.payload.note;

            // if (state.calcDetail[field].maxLength) {
            //     state.calcDetail[field].value = value.slice(0, state.calcDetail[field].maxLength);
            // } else {
            //     state.calcDetail[field].value = value;
            // }

            if (value !== undefined) {
                state.calcDetail[field].value = value;
            }

            if (maxValue !== undefined) {
                state.calcDetail[field].maxValue = maxValue;
            }

            if (minValue !== undefined) {
                state.calcDetail[field].minValue = minValue;
            }

            if (errorMessage !== undefined) {
                state.calcDetail[field].errorMessage = errorMessage;
            }

            if (visible !== undefined) {
                state.calcDetail[field].visible = visible;
            }

            if (note !== undefined) {
                state.calcDetail[field].note = note;
            }
        },
        CalcValidateChange: (state, action) => {
            const field = action.payload.field;
            const errorMessage = action.payload.errorMessage;
            state.calcDetail[field].errorMessage = errorMessage;
        },
        formsCalcRangeInputChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            if (state.calcDetail[field].maxLength) {
                state.calcDetail[field].value = value.slice(0, state.calcDetail[field].maxLength);
            } else {
                state.calcDetail[field].value = value;
            }
            state.calcDetail[field].count += 1;
        },
        formsCalcPropsChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.calcDetail[field] = value;
            console.log(field, value)
        },
        formsDropleadDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;
            const errorMessage = action.payload.errorMessage;
            if (state.dropleadDetail[field].maxLength) {
                state.dropleadDetail[field].value = value.slice(0, state.dropleadDetail[field].maxLength);
            } else {
                state.dropleadDetail[field].value = value;
            }

            state.dropleadDetail[field].errorMessage = errorMessage;
        },
        DropleadValidateChange: (state, action) => {
            const field = action.payload.field;
            const errorMessage = action.payload.errorMessage;
            state.dropleadDetail[field].errorMessage = errorMessage;
        },
        DropleadListChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.dropleadDetail[field].option = value;
        },
    },
})

// Action creators are generated for each case reducer function
export const { searchDataChange, searchListChange, searchIonRangeChange, searchIonRangeListChange, updateIonRange, CheckBoxChange, ClearSearch,
    updateSearchResultList, likePropertyList, updatesearchFilterCheckBox, searchResultDataChange, OnPropertyListLoading,
    updateLikeInList, searchResultPageIndexChange, updatePropertyDetail,
    formsCalcDataChange, CalcValidateChange, formsCalcRangeInputChange, formsCalcPropsChange,
    formsDropleadDataChange, DropleadValidateChange, DropleadListChange } = propertySlice.actions

export default propertySlice.reducer